// extracted by mini-css-extract-plugin
export default {"laws":"LawsUzb_laws__ansx9","laws__inner":"LawsUzb_laws__inner__y-DQR","laws__title":"LawsUzb_laws__title__yra89","laws__link":"LawsUzb_laws__link__maByb"};